(() => {
  const box = document.getElementById('bung-social-proof');
  if (!box || box.dataset.ready) return;
  box.dataset.ready = 'true';
  const KEY = 'bung-social-v1';
  let state = { count: 0, closed: false, seen: [] };
  try { state = { ...state, ...JSON.parse(sessionStorage.getItem(KEY) || '{}') }; } catch (_) {}
  if (state.closed || state.count >= 3) return;
  let feed;
  try { feed = JSON.parse(box.dataset.feed); } catch (_) { return; }
  box.removeAttribute('data-feed');
  const generated = Date.parse(feed.generatedAt);
  const fresh = () => Number.isFinite(generated) && Date.now() - generated >= -300000 && Date.now() - generated < 3 * 3600000;
  if (!fresh()) return;
  const clean = (text, limit) => String(text || '').replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, limit);
  const events = (Array.isArray(feed.events) ? feed.events : []).filter(e => {
    const age = Date.now() - Date.parse(e.createdAt);
    return age >= 0 && age < 7 * 86400000 && clean(e.firstName, 30) && clean(e.city, 50) && Array.isArray(e.products) && e.products.some(p => p.quantity === 6);
  });
  const save = () => { try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (_) {} };
  let lastInteraction = 0;
  let next = Date.now() + 15000;
  let hideAt = 0;
  let index = 0;
  const visible = el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
  const busy = () => document.hidden || Date.now() - lastInteraction < 12000 || document.activeElement?.matches('input,select,textarea,[contenteditable="true"]') || [...document.querySelectorAll('dialog[open],[role="dialog"],[aria-modal="true"]')].some(visible);
  const hide = () => { box.hidden = true; hideAt = 0; };
  const pause = event => {
    if (box.contains(event.target)) return;
    if (event.target.closest('input,select,textarea,form,[id*="rsi"],[class*="rsi-"],#buttonContainerProduct')) { lastInteraction = Date.now(); hide(); next = Date.now() + 15000; }
  };
  document.addEventListener('focusin', pause);
  document.addEventListener('pointerdown', pause, { passive: true });
  document.addEventListener('visibilitychange', () => { if (document.hidden) hide(); });
  const formatter = new Intl.RelativeTimeFormat(box.dataset.locale || 'es', { numeric: 'always' });
  const ago = date => {
    const seconds = Math.max(1, Math.floor((Date.now() - Date.parse(date)) / 1000));
    if (seconds < 60) return formatter.format(-seconds, 'second');
    if (seconds < 3600) return formatter.format(-Math.floor(seconds / 60), 'minute');
    if (seconds < 86400) return formatter.format(-Math.floor(seconds / 3600), 'hour');
    return formatter.format(-Math.floor(seconds / 86400), 'day');
  };
  const timer = setInterval(() => {
    if (state.closed || !fresh()) { hide(); clearInterval(timer); return; }
    if (hideAt && (Date.now() >= hideAt || busy())) { hide(); next = Date.now() + 30000; }
    if (!box.hidden || Date.now() < next || busy()) return;
    if (state.count >= 3 || index >= events.length) { clearInterval(timer); return; }
    const event = events[index++];
    const identity = [event.createdAt, event.firstName, event.city].join('|');
    if (state.seen.includes(identity)) return;
    box.querySelector('p').textContent = box.dataset.text.replace('[name]', clean(event.firstName, 30).split(/\s+/)[0]).replace('[city]', clean(event.city, 50));
    const time = box.querySelector('time');
    time.dateTime = event.createdAt;
    time.textContent = ago(event.createdAt);
    box.hidden = false;
    hideAt = Date.now() + 5000;
    state.count++;
    state.seen.push(identity);
    save();
  }, 500);
  box.querySelector('button').addEventListener('click', () => { state.closed = true; save(); hide(); clearInterval(timer); });
})();
